// Quran data: 114 Surahs with their names, translations, and ayah counts
export interface Surah {
  number: number;
  name: string;
  englishName: string;
  ayahCount: number;
  juz: number[]; // Which juz(s) this surah spans
}

export const SURAHS: Surah[] = [
  { number: 1, name: "Al-Fatihah", englishName: "The Opener", ayahCount: 7, juz: [1] },
  { number: 2, name: "Al-Baqarah", englishName: "The Cow", ayahCount: 286, juz: [1, 2, 3] },
  { number: 3, name: "Ali 'Imran", englishName: "Family of Imran", ayahCount: 200, juz: [3, 4] },
  { number: 4, name: "An-Nisa", englishName: "The Women", ayahCount: 176, juz: [4, 5, 6] },
  { number: 5, name: "Al-Ma'idah", englishName: "The Table Spread", ayahCount: 120, juz: [6, 7] },
  { number: 6, name: "Al-An'am", englishName: "The Cattle", ayahCount: 165, juz: [7, 8] },
  { number: 7, name: "Al-A'raf", englishName: "The Heights", ayahCount: 206, juz: [8, 9] },
  { number: 8, name: "Al-Anfal", englishName: "The Spoils of War", ayahCount: 75, juz: [9, 10] },
  { number: 9, name: "At-Tawbah", englishName: "The Repentance", ayahCount: 129, juz: [10, 11] },
  { number: 10, name: "Yunus", englishName: "Jonah", ayahCount: 109, juz: [11] },
  { number: 11, name: "Hud", englishName: "Hud", ayahCount: 123, juz: [11, 12] },
  { number: 12, name: "Yusuf", englishName: "Joseph", ayahCount: 111, juz: [12, 13] },
  { number: 13, name: "Ar-Ra'd", englishName: "The Thunder", ayahCount: 43, juz: [13] },
  { number: 14, name: "Ibrahim", englishName: "Abraham", ayahCount: 52, juz: [13] },
  { number: 15, name: "Al-Hijr", englishName: "The Rocky Tract", ayahCount: 99, juz: [14] },
  { number: 16, name: "An-Nahl", englishName: "The Bee", ayahCount: 128, juz: [14] },
  { number: 17, name: "Al-Isra", englishName: "The Night Journey", ayahCount: 111, juz: [15] },
  { number: 18, name: "Al-Kahf", englishName: "The Cave", ayahCount: 110, juz: [15, 16] },
  { number: 19, name: "Maryam", englishName: "Mary", ayahCount: 98, juz: [16] },
  { number: 20, name: "Taha", englishName: "Ta-Ha", ayahCount: 135, juz: [16] },
  { number: 21, name: "Al-Anbya", englishName: "The Prophets", ayahCount: 112, juz: [17] },
  { number: 22, name: "Al-Hajj", englishName: "The Pilgrimage", ayahCount: 78, juz: [17] },
  { number: 23, name: "Al-Mu'minun", englishName: "The Believers", ayahCount: 118, juz: [18] },
  { number: 24, name: "An-Nur", englishName: "The Light", ayahCount: 64, juz: [18] },
  { number: 25, name: "Al-Furqan", englishName: "The Criterion", ayahCount: 77, juz: [18, 19] },
  { number: 26, name: "Ash-Shu'ara", englishName: "The Poets", ayahCount: 227, juz: [19] },
  { number: 27, name: "An-Naml", englishName: "The Ant", ayahCount: 93, juz: [19, 20] },
  { number: 28, name: "Al-Qasas", englishName: "The Stories", ayahCount: 88, juz: [20] },
  { number: 29, name: "Al-'Ankabut", englishName: "The Spider", ayahCount: 69, juz: [20, 21] },
  { number: 30, name: "Ar-Rum", englishName: "The Romans", ayahCount: 60, juz: [21] },
  { number: 31, name: "Luqman", englishName: "Luqman", ayahCount: 34, juz: [21] },
  { number: 32, name: "As-Sajdah", englishName: "The Prostration", ayahCount: 30, juz: [21] },
  { number: 33, name: "Al-Ahzab", englishName: "The Combined Forces", ayahCount: 73, juz: [21, 22] },
  { number: 34, name: "Saba", englishName: "Sheba", ayahCount: 54, juz: [22] },
  { number: 35, name: "Fatir", englishName: "Originator", ayahCount: 45, juz: [22] },
  { number: 36, name: "Ya-Sin", englishName: "Ya Sin", ayahCount: 83, juz: [22, 23] },
  { number: 37, name: "As-Saffat", englishName: "Those who set the Ranks", ayahCount: 182, juz: [23] },
  { number: 38, name: "Sad", englishName: "The Letter Sad", ayahCount: 88, juz: [23] },
  { number: 39, name: "Az-Zumar", englishName: "The Troops", ayahCount: 75, juz: [23, 24] },
  { number: 40, name: "Ghafir", englishName: "The Forgiver", ayahCount: 85, juz: [24] },
  { number: 41, name: "Fussilat", englishName: "Explained in Detail", ayahCount: 54, juz: [24, 25] },
  { number: 42, name: "Ash-Shuraa", englishName: "The Consultation", ayahCount: 53, juz: [25] },
  { number: 43, name: "Az-Zukhruf", englishName: "The Ornaments of Gold", ayahCount: 89, juz: [25] },
  { number: 44, name: "Ad-Dukhan", englishName: "The Smoke", ayahCount: 59, juz: [25] },
  { number: 45, name: "Al-Jathiyah", englishName: "The Crouching", ayahCount: 37, juz: [25] },
  { number: 46, name: "Al-Ahqaf", englishName: "The Wind-Curved Sandhills", ayahCount: 35, juz: [26] },
  { number: 47, name: "Muhammad", englishName: "Muhammad", ayahCount: 38, juz: [26] },
  { number: 48, name: "Al-Fath", englishName: "The Victory", ayahCount: 29, juz: [26] },
  { number: 49, name: "Al-Hujurat", englishName: "The Rooms", ayahCount: 18, juz: [26] },
  { number: 50, name: "Qaf", englishName: "The Letter Qaf", ayahCount: 45, juz: [26] },
  { number: 51, name: "Adh-Dhariyat", englishName: "The Winnowing Winds", ayahCount: 60, juz: [26, 27] },
  { number: 52, name: "At-Tur", englishName: "The Mount", ayahCount: 49, juz: [27] },
  { number: 53, name: "An-Najm", englishName: "The Star", ayahCount: 62, juz: [27] },
  { number: 54, name: "Al-Qamar", englishName: "The Moon", ayahCount: 55, juz: [27] },
  { number: 55, name: "Ar-Rahman", englishName: "The Beneficent", ayahCount: 78, juz: [27] },
  { number: 56, name: "Al-Waqi'ah", englishName: "The Inevitable", ayahCount: 96, juz: [27] },
  { number: 57, name: "Al-Hadid", englishName: "The Iron", ayahCount: 29, juz: [27] },
  { number: 58, name: "Al-Mujadila", englishName: "The Pleading Woman", ayahCount: 22, juz: [28] },
  { number: 59, name: "Al-Hashr", englishName: "The Exile", ayahCount: 24, juz: [28] },
  { number: 60, name: "Al-Mumtahanah", englishName: "She that is to be examined", ayahCount: 13, juz: [28] },
  { number: 61, name: "As-Saf", englishName: "The Ranks", ayahCount: 14, juz: [28] },
  { number: 62, name: "Al-Jumu'ah", englishName: "Friday", ayahCount: 11, juz: [28] },
  { number: 63, name: "Al-Munafiqun", englishName: "The Hypocrites", ayahCount: 11, juz: [28] },
  { number: 64, name: "At-Taghabun", englishName: "The Mutual Disillusion", ayahCount: 18, juz: [28] },
  { number: 65, name: "At-Talaq", englishName: "The Divorce", ayahCount: 12, juz: [28] },
  { number: 66, name: "At-Tahrim", englishName: "The Prohibition", ayahCount: 12, juz: [28] },
  { number: 67, name: "Al-Mulk", englishName: "The Sovereignty", ayahCount: 30, juz: [29] },
  { number: 68, name: "Al-Qalam", englishName: "The Pen", ayahCount: 52, juz: [29] },
  { number: 69, name: "Al-Haqqah", englishName: "The Reality", ayahCount: 52, juz: [29] },
  { number: 70, name: "Al-Ma'arij", englishName: "The Ascending Stairways", ayahCount: 44, juz: [29] },
  { number: 71, name: "Nuh", englishName: "Noah", ayahCount: 28, juz: [29] },
  { number: 72, name: "Al-Jinn", englishName: "The Jinn", ayahCount: 28, juz: [29] },
  { number: 73, name: "Al-Muzzammil", englishName: "The Enshrouded One", ayahCount: 20, juz: [29] },
  { number: 74, name: "Al-Muddaththir", englishName: "The Cloaked One", ayahCount: 56, juz: [29] },
  { number: 75, name: "Al-Qiyamah", englishName: "The Resurrection", ayahCount: 40, juz: [29] },
  { number: 76, name: "Al-Insan", englishName: "The Man", ayahCount: 31, juz: [29] },
  { number: 77, name: "Al-Mursalat", englishName: "The Emissaries", ayahCount: 50, juz: [29] },
  { number: 78, name: "An-Naba", englishName: "The Tidings", ayahCount: 40, juz: [30] },
  { number: 79, name: "An-Nazi'at", englishName: "Those who drag forth", ayahCount: 46, juz: [30] },
  { number: 80, name: "'Abasa", englishName: "He Frowned", ayahCount: 42, juz: [30] },
  { number: 81, name: "At-Takwir", englishName: "The Overthrowing", ayahCount: 29, juz: [30] },
  { number: 82, name: "Al-Infitar", englishName: "The Cleaving", ayahCount: 19, juz: [30] },
  { number: 83, name: "Al-Mutaffifin", englishName: "The Defrauding", ayahCount: 36, juz: [30] },
  { number: 84, name: "Al-Inshiqaq", englishName: "The Sundering", ayahCount: 25, juz: [30] },
  { number: 85, name: "Al-Buruj", englishName: "The Mansions of the Stars", ayahCount: 22, juz: [30] },
  { number: 86, name: "At-Tariq", englishName: "The Nightcommer", ayahCount: 17, juz: [30] },
  { number: 87, name: "Al-A'la", englishName: "The Most High", ayahCount: 19, juz: [30] },
  { number: 88, name: "Al-Ghashiyah", englishName: "The Overwhelming", ayahCount: 26, juz: [30] },
  { number: 89, name: "Al-Fajr", englishName: "The Dawn", ayahCount: 30, juz: [30] },
  { number: 90, name: "Al-Balad", englishName: "The City", ayahCount: 20, juz: [30] },
  { number: 91, name: "Ash-Shams", englishName: "The Sun", ayahCount: 15, juz: [30] },
  { number: 92, name: "Al-Layl", englishName: "The Night", ayahCount: 21, juz: [30] },
  { number: 93, name: "Ad-Duhaa", englishName: "The Morning Hours", ayahCount: 11, juz: [30] },
  { number: 94, name: "Ash-Sharh", englishName: "The Relief", ayahCount: 8, juz: [30] },
  { number: 95, name: "At-Tin", englishName: "The Fig", ayahCount: 8, juz: [30] },
  { number: 96, name: "Al-'Alaq", englishName: "The Clot", ayahCount: 19, juz: [30] },
  { number: 97, name: "Al-Qadr", englishName: "The Power", ayahCount: 5, juz: [30] },
  { number: 98, name: "Al-Bayyinah", englishName: "The Clear Proof", ayahCount: 8, juz: [30] },
  { number: 99, name: "Az-Zalzalah", englishName: "The Earthquake", ayahCount: 8, juz: [30] },
  { number: 100, name: "Al-'Adiyat", englishName: "The Courser", ayahCount: 11, juz: [30] },
  { number: 101, name: "Al-Qari'ah", englishName: "The Calamity", ayahCount: 11, juz: [30] },
  { number: 102, name: "At-Takathur", englishName: "The Rivalry in world increase", ayahCount: 8, juz: [30] },
  { number: 103, name: "Al-'Asr", englishName: "The Declining Day", ayahCount: 3, juz: [30] },
  { number: 104, name: "Al-Humazah", englishName: "The Traducer", ayahCount: 9, juz: [30] },
  { number: 105, name: "Al-Fil", englishName: "The Elephant", ayahCount: 5, juz: [30] },
  { number: 106, name: "Quraysh", englishName: "Quraysh", ayahCount: 4, juz: [30] },
  { number: 107, name: "Al-Ma'un", englishName: "The Small Kindnesses", ayahCount: 7, juz: [30] },
  { number: 108, name: "Al-Kawthar", englishName: "The Abundance", ayahCount: 3, juz: [30] },
  { number: 109, name: "Al-Kafirun", englishName: "The Disbelievers", ayahCount: 6, juz: [30] },
  { number: 110, name: "An-Nasr", englishName: "The Divine Support", ayahCount: 3, juz: [30] },
  { number: 111, name: "Al-Masad", englishName: "The Palm Fiber", ayahCount: 5, juz: [30] },
  { number: 112, name: "Al-Ikhlas", englishName: "The Sincerity", ayahCount: 4, juz: [30] },
  { number: 113, name: "Al-Falaq", englishName: "The Daybreak", ayahCount: 5, juz: [30] },
  { number: 114, name: "An-Nas", englishName: "Mankind", ayahCount: 6, juz: [30] },
];

// Total ayahs in the Quran
export const TOTAL_AYAHS = 6236;
export const TOTAL_PAGES = 604;
export const TOTAL_JUZ = 30;

// Get surah by number
export const getSurah = (number: number): Surah | undefined => {
  return SURAHS.find(s => s.number === number);
};

// Get surahs in a specific juz
export const getSurahsInJuz = (juz: number): Surah[] => {
  return SURAHS.filter(s => s.juz.includes(juz));
};

// Calculate total ayahs read up to a certain surah and ayah
export const calculateTotalAyahsRead = (surahNumber: number, ayahNumber: number): number => {
  let total = 0;
  for (let i = 0; i < surahNumber - 1; i++) {
    total += SURAHS[i].ayahCount;
  }
  return total + ayahNumber;
};

// Calculate overall progress percentage
export const calculateQuranProgress = (surahNumber: number, ayahNumber: number): number => {
  const ayahsRead = calculateTotalAyahsRead(surahNumber, ayahNumber);
  return (ayahsRead / TOTAL_AYAHS) * 100;
};
